import { useTranslation } from 'react-i18next';

type P = {
  title: string;
};

const Header = ({ title }: P) => {
  const { t } = useTranslation();

  return <h2 className="form__header">{t(title)}</h2>;
};

export default Header;
